export const DEFAULT_NS = "common" as const;

export const NAMESPACES = {
	common: "common",
	profile: "profile",
	auth: "auth",
	cart: "cart",
	checkout: "checkout",

	product: "product",
	vendor: "vendor",
	doctor: "doctor",
	clinic: "clinic",
} as const;

export const AVAILABLE_NAMESPACES = Object.values(NAMESPACES);

export type AvailableNamespaces = keyof typeof NAMESPACES;
